/**
 * 获取API基础URL
 * 自动根据当前访问的主机名设置 API URL
 * 在开发环境中，使用相对路径让 Vite 代理处理
 * 在生产环境中，使用完整的 URL
 */
function getApiBaseUrl(): string {
  // 如果设置了环境变量，优先使用
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL
  }
  
  // 在开发模式下，使用相对路径（通过 Vite 代理）
  if (import.meta.env.DEV) {
    return '' // 空字符串表示使用相对路径，会被 Vite 代理处理
  }
  
  // 生产模式：使用当前主机名
  const protocol = window.location.protocol
  const hostname = window.location.hostname
  const port = '3001' // 后端端口
  return `${protocol}//${hostname}:${port}`
}

/**
 * 获取完整的图片URL
 * @param imagePath 图片路径（通常以/content开头）
 * @returns 完整的URL
 */
export function getImageUrl(imagePath: string | undefined): string | undefined {
  if (!imagePath) return undefined
  
  const baseUrl = getApiBaseUrl()
  return `${baseUrl}${imagePath}`
}

/**
 * 获取专辑封面URL
 * @param albumCover 专辑封面路径
 * @returns 完整的URL或undefined
 */
export function getAlbumCoverUrl(albumCover: string | undefined): string | undefined {
  return getImageUrl(albumCover)
}

